module.exports = __webpack_public_path__ + "static/media/monstermash.9e7aa690.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/monstermash.jpeg
// module id = 77
// module chunks = 0